import AccountIndividualDetailsForm from './AccountIndividualDetailsForm'

export default AccountIndividualDetailsForm
